/**
 * bcf-checkout.js
 * Unified checkout interception for configured (MSRP) products.
 *
 * Replaces the two inline <script> blocks in sections/main-cart.liquid
 * and sections/quick-cart.liquid.
 *
 * Why delegation on document (capture phase):
 * - Inline scripts inside section markup do NOT re-execute when the
 *   quick-cart is re-rendered via the Section Rendering API (innerHTML
 *   injection). A per-button listener therefore silently disappears
 *   after the first add-to-cart, letting customers check out at the
 *   0.01 kr placeholder price.
 * - Binding once on document also avoids the double-binding that
 *   occurred when both sections ran querySelectorAll on the same buttons.
 *
 * Include from theme.liquid:
 *   <script src="{{ 'bcf-checkout.js' | asset_url }}" defer></script>
 */
(function () {
  var WORKER_URL = 'https://shopify-bcf-checkout.jonas-hund.workers.dev';
  var busy = false;

  function hasMsrpItem(items) {
    return items.some(function (item) {
      return item.properties && item.properties._MSRP != null;
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest("button[name='checkout']");
      if (!btn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      if (busy) return;
      busy = true;
      handleCheckout(btn);
    },
    true // capture phase: fires before theme.min.js handlers
  );

  async function handleCheckout(btn) {
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Vent venligst...';

    try {
      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();

      if (!hasMsrpItem(cart.items)) {
        window.location.href = '/checkout';
        return;
      }

      var workerRes = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cart.items })
      });

      if (!workerRes.ok) throw new Error('Worker HTTP ' + workerRes.status);

      var data = await workerRes.json();

      if (data.checkoutUrl) {
        window.location.href = data.checkoutUrl;
      } else {
        throw new Error('Worker returned no checkoutUrl');
      }
    } catch (err) {
      console.error('BCF checkout error:', err);
      // Deliberately NO fallback to /checkout here: falling through
      // would let the order complete at the 0.01 kr placeholder price.
      alert('Der opstod en fejl. Pr\u00f8v igen.');
      btn.disabled = false;
      btn.textContent = originalText;
      busy = false;
    }
  }
})();